import { Link } from 'react-router-dom';
import StarRating from '@/components/base/StarRating';
import { platformRatings } from '@/mocks/platforms';

interface PlatformCardProps {
  id: string;
  name: string;
  logo: string;
  rating: number;
  category: string;
  tags: string[];
  description: string;
  price: string;
  contentCount: string;
  color: string;
}

export default function PlatformCard({ id, name, logo, rating, category, tags, description, price, contentCount, color }: PlatformCardProps) {
  const detailRatings = platformRatings[id];

  return (
    <div className="bg-background-100 rounded-xl overflow-hidden border border-background-200/50 hover:border-primary-500/20 transition-all duration-300 group cursor-pointer">
      <div className="p-5">
        <div className="flex items-start gap-4">
          <div className="w-16 h-16 rounded-xl overflow-hidden flex-shrink-0 bg-background-200 flex items-center justify-center">
            <div
              className="w-12 h-12 rounded-lg flex items-center justify-center text-2xl font-bold"
              style={{ backgroundColor: `${color}20`, color: color }}
            >
              {name.charAt(0)}
            </div>
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center justify-between gap-2">
              <h3 className="text-lg font-heading font-semibold text-foreground-800">{name}</h3>
              <span className="text-xs text-foreground-400 bg-background-200 px-2 py-0.5 rounded-full whitespace-nowrap">
                {contentCount}
              </span>
            </div>
            <StarRating rating={rating} size="sm" detailed ratings={detailRatings} />
          </div>
        </div>

        <p className="mt-3 text-sm text-foreground-500 leading-relaxed line-clamp-2">
          {description}
        </p>

        <div className="mt-3 flex flex-wrap gap-1.5">
          {tags.map((tag) => (
            <span
              key={tag}
              className="text-xs px-2.5 py-1 rounded-full bg-accent-100/20 text-accent-400 border border-accent-200/20 whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>

        <div className="mt-4 flex items-center justify-between">
          <span className="text-sm font-semibold text-primary-500">{price}</span>
          <Link
            to={`/article/ultimate-review-2026`}
            className="text-xs text-foreground-400 hover:text-primary-500 transition-colors duration-200 flex items-center gap-1 cursor-pointer"
          >
            查看评测
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
      </div>
    </div>
  );
}